import { FC } from 'react';
import { Avatar, Typography } from 'antd';

import { userService } from '@/services/database';
import VerifiedDestructiveActionModal from '@/shared/components/modals/VerifiedDestructiveActionModal';
import { useUserStore } from '@/stores';
import { SetStateMethod } from '@/types';

interface DeleteAccountModalProps {
    handleDeleteAccount: (verificationCode: string) => Promise<void>;
    open: boolean;
    setOpen: SetStateMethod<boolean>;
}

const DeleteAccountModal: FC<DeleteAccountModalProps> = ({ handleDeleteAccount, open, setOpen }): JSX.Element => {
    const { selectedUser: user } = useUserStore();
    const emailAddress = user?.emailAddress ?? '';
    const userName = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || emailAddress || 'Your Account';

    return (
        <VerifiedDestructiveActionModal
            acknowledgementLabel='I understand that my account and associated data will be permanently deleted.'
            actionLabel='Delete My Account'
            alertDescription='Deleting your account permanently removes your profile and any workspaces you solely own, including their resources and membership records. Export any data you need before continuing.'
            emailAddress={emailAddress}
            errorMessage='Unable to delete account'
            onCancel={() => setOpen(false)}
            onConfirm={handleDeleteAccount}
            onRequestCode={() => userService.requestDeletionVerification()}
            open={open}
            title='Verify Account Deletion Request'
        >
            <div style={{ alignItems: 'center', display: 'flex', gap: '0.75rem' }}>
                <Avatar size={40} src={user?.avatar} />
                <div style={{ minWidth: 0 }}>
                    <Typography.Text strong>{userName}</Typography.Text>
                    <small style={{ display: 'block' }}>{emailAddress}</small>
                </div>
            </div>
        </VerifiedDestructiveActionModal>
    );
};

export default DeleteAccountModal;
